const { fontFamily } = require('tailwindcss/defaultTheme')

module.exports = {
	lt: ['NextLTPro', ...fontFamily.sans].join(', '),
}
